import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ark_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/quote/")) {
      localStorage.removeItem("ark_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  const status = e?.response?.status;
  if (status === 503) return "ARK's server can't reach its database right now. Please try again in a moment.";
  if (status >= 500) return "The ARK server hit an unexpected error. Please try again in a moment.";
  if (e?.code === "ERR_NETWORK" || e?.message === "Network Error")
    return "Can't reach the ARK server. Check your connection and try again.";
  return e?.message || "Something went wrong";
};

export const fmt = (cents) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format((cents || 0) / 100);

export const LOGO_URL = "https://cdn.shopify.com/s/files/1/0607/5491/9639/files/ARKLogo.png?v=1636138147";
